<template lang="pug">
Dialog(
  :open="toValue(open)"
  @close="() => emit('close')"
  v-bind="rootAttrs"
)

  div(class="fixed inset-0 bg-black/25")
  div(class="fixed inset-0 overflow-y-auto")
    div(class="flex min-h-full items-center justify-center p-4 text-center")
        DialogPanel(class="w-full transform overflow-hidden rounded-2xl bg-primary-100 dark_bg-primary-950 p-6 text-left align-middle shadow-xl transition-all flex flex-col gap-4 duration-500 relative z-0" 
        :class="attrs.class")
                
          .absolute.inset-0.m-0.bg-white.dark_bg-gray-800.bg-opacity-50.dark_bg-opacity-50.z-0

          button.btn.btn-icon.opacity-50.aspect-square.flex.items-center.justify-center.font-bold.text-xl.w-8.h-8.absolute.top-4.right-4.z-20(
            @click="close"
            type="button"
          ) &times;

          .z-10
            slot
</template>

<script setup lang="ts">
import { Dialog, DialogPanel } from '@headlessui/vue';
import { toValue } from 'vue';

import { computed } from 'vue';
import { useAttrs } from 'vue';

const attrs = useAttrs();

// exclude class from root attrs
const rootAttrs = computed(() => {
  const { class: _, ...rest } = attrs;
  return rest;
});

defineProps<{ open: ReturnType<typeof toValue<boolean>> }>();

const emit = defineEmits(['close']);
const close = () => emit('close');
</script>
